<template>
  <v-select
    placeholder="Selecciona una o mas palabras existentes"
    :options="descriptors"
    multiple
    :value="value"
    @input="onInput"
  >
  </v-select>
</template>

<script>
import Descriptors from '@/febos/chile/dnt/components/wizard/companies/60100003-2/utils/Descriptors';

export default {
  name: 'Keywords',
  props: ['value'],
  data() {
    return {
      descriptors: Descriptors
    };
  },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },
  }
};
</script>

<style>

</style>
